(function() {
  var MachineryForm, ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  MachineryForm = App.loadClass("grower::viewmodels/machinery/Form");

  ValidationEngine = App.loadClass("core::ValidationEngine");

  exports.DialogViewMachinery_Handler = (function(superClass) {
    extend(DialogViewMachinery_Handler, superClass);

    function DialogViewMachinery_Handler() {
      DialogViewMachinery_Handler.__super__.constructor.call(this);
      this.wantEdit = false;
      this.wantAdd = false;
      this.refreshNavHandler = false;
      this.machinery_id = null;
      this.machinery_type = null;
    }

    DialogViewMachinery_Handler.prototype.init = function() {
      this.loadLayoutPostOptions = {
        'id': this.machinery_id,
        'machinery_type_id': this.machinery_type
      };
      this.layoutUrl = 'backend/grower/machinery/load-layout-addedit';
      return this.createDialog();
    };

    DialogViewMachinery_Handler.prototype.destroy = function() {
      ko.cleanNode(this.dialog[0]);
      return DialogViewMachinery_Handler.__super__.destroy.call(this);
    };

    DialogViewMachinery_Handler.prototype.afterLoadLayout = function(selector, response) {
      var ref, ref1, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        this.openDialog();
        return;
      }
      $.mask.definitions['m'] = '[.0-9]';
      this.dialog.find('#swath_width').mask('?mmmmmm', {
        placeholder: ""
      });
      this.dialog.find('#till_width').mask('?mmmmmm', {
        placeholder: ""
      });
      this.dialog.find('#num_rows').mask('?99', {
        placeholder: ""
      });
      this.successAction = function() {
        return this.parent.refresh();
      };
      ths = this;
      this.koData = new MachineryForm(this, (ref1 = response.data) != null ? ref1.type : void 0, response.data);
      if (this.wantEdit || this.wantAdd) {
        this.koData.setEditing();
      }
      ko.applyBindings(this.koData, this.dialog[0]);
      this.validator = new ValidationEngine();
      this.validator.makeFormValidator('machinery', '.validationContainer', '#addedit_machinery_errors', (function(_this) {
        return function(valid) {
          if (valid) {
            return ths.save('Saving...');
          } else {

          }
        };
      })(this));
      this.validator.registerRule({
        selector: '.validate-swath-till-width',
        text: '%s is too high or is an invalid decimal value',
        func: function(elem) {
          var val;
          val = elem.val();
          return !val || $(elem).val().match(/^\d{0,3}(\.\d{1})?$/);
        }
      });
      this.validator.registerRule({
        'selector': '.validate-maybe-required',
        'text': '%s is required',
        'func': function(elem) {
          if (!ths.koData.layer.variable_rate()) {
            return true;
          } else {
            if (ths.koData.layer[$(elem).attr('name')]() != null) {
              return true;
            }
          }
          return false;
        }
      });
      this.validator.registerRule({
        'selector': '.validate-ko-required',
        'text': '%s is required',
        'func': function(elem) {
          if (ths.koData.layer[$(elem).attr('name')]() != null) {
            return true;
          }
          return false;
        }
      });
      this.validator.registerRule({
        'selector': '.validate-length',
        'text': '%s is too large',
        'func': function(elem) {
          return $(elem).val().length < 8;
        }
      });
      this.validator.registerRule({
        'selector': '.validate-unique-nickname',
        'text': 'You have already used this nickname.  Please choose a unique nickname.',
        'ajax': {
          'url': 'backend/grower/machinery/validate-unique-nickname',
          'data': function(elem) {
            var ref2;
            return {
              'nick': elem.val(),
              'type': (ref2 = response.data) != null ? ref2.type : void 0,
              'id': ths.koData.layer.id
            };
          }
        },
        'func': function(data) {
          return data === 'good';
        }
      });
      return this.openDialog();
    };

    DialogViewMachinery_Handler.prototype.getPostData = function() {
      var data, datac;
      datac = $.extend(true, {}, this.koData.layer);
      delete datac.machinery_subtypes;
      delete datac.machinery_makes;
      delete datac.machinery_models;
      delete datac.controller_makes;
      delete datac.controller_models;
      delete datac.selected_subtype;
      delete datac.selected_make;
      if ((datac.selected_controller_make != null) && (datac.selected_controller_make() != null)) {
        datac.selected_controller_make().models = null;
        delete datac.selected_controller_make().models;
      }
      if (datac.nickname()) {
        datac.nickname(datac.nickname().replace('&', '', 'g'));
      }
      data = "json=" + ko.toJSON(datac);
      return data;
    };

    DialogViewMachinery_Handler.prototype.submitAction = function() {
      return this.validator.validateAll();
    };

    return DialogViewMachinery_Handler;

  })(FullPageHandler);

}).call(this);
